import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectIssueDesc } from '@store/order/selectors';
import { setIssueDesc } from '@store/order/slice';
import SurgerySegments from '@pages/order/surgery-info/SurgerySegments';
import { TextArea } from '@components/text-field/TextArea';
import SurgeryDate from '@pages/order/surgery-info/SurgeryDate';



const SurgeryInfo = () => {
	const { t } = useTranslation('forms');

	const issueDesc = useSelector(selectIssueDesc);
	const dispatch = useDispatch();
	const updateIssueDesc = (value: string | null) => dispatch(setIssueDesc(value));

	return (
		<div className='surgery-info-section'>

			<SurgerySegments />

			<TextArea
				label={t('surgeryInfo.info.sectionLabel')}
				rounded={true}
				maxLength={250}
				value={issueDesc ? issueDesc : undefined}
				onChange={(value: string) => !value && value.length === 0 ? updateIssueDesc(null) : updateIssueDesc(value)} />

			<SurgeryDate />

		</div>
	);
};

export default SurgeryInfo;